import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/page/Main'
import Order from '@/page/Order'
import PayDetail from '@/page/PayDetail'
import OrderPay from '@/page/OrderPay'
import HomeMenu from '@/page/userCenter/HomeMenu'
import Register from '@/page/register'
import Email from '@/page/emailIndex'
import RegSuccess from '@/page/RegSuccess'
import PaySuccess from '@/page/PaySuccess'
import Account from '@/page/userCenter/account'
import Message from '@/page/userCenter/message'
import OrderList from '@/components/order/orderlist.vue'
import SubscriptionOrdersList from '@/components/order/subscriptionOrdersList.vue'
import ChangePwd from '@/page/userCenter/changepassword'
import AuthCenter from '@/page/userCenter/authorcenter'
import Address from '@/page/userCenter/address'
import CloudDisk from '@/page/userCenter/clouddisk'
import CloudDiskOne from '@/page/userCenter/clouddiskone'
import CloudDiskTwo from '@/page/userCenter/clouddisktwo'
import FtpManager from '@/page/userCenter/ftpmanager'
import OrderDetail from '@/components/order/orderdetail'
import Vouchers from '@/components/vouchers/availablevouchers'
import Invoice from '@/components/invoice/invoice'
import GetInvoice from '@/components/invoice/getInvoice'
import ManagerInvoice from '@/components/invoice/managerinvoice'
import Comment from '@/page/userCenter/feedcommit'
import Password from '@/page/Password'
import EmailPwd from '@/page/EmailPwd'
import RegSuccessPwd from '@/page/RegSuccessPwd'
import ResetSuccessPwd from '@/page/ResetSuccessPwd'
import GetUrl from '@/page/userCenter/geturl'

Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'mainindex',
    //   component: Main
    // },
    {
      path: '/order',
      name: 'order',
      component: Order,
      children: [
        {
          path: 'payDetail',
          name: 'payDetail',
          component: PayDetail
        },
        {
          path: 'orderPay',
          name: 'orderPay',
          component: OrderPay
        },
        {
          path: 'paySuccess',
          name: 'paySuccess',
          component: PaySuccess
        }
      ]
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/email',
      name: 'email',
      component: Email
    },
    {
      path: '/regSuccess',
      name: 'regSuccess',
      component: RegSuccess
    },
    {
      path: '/password',
      name: 'password',
      component: Password
    },
    {
      path: '/emailpwd',
      name: 'emailpwd',
      component: EmailPwd
    },
    {
      path: '/regSuccesspwd',
      name: 'regSuccesspwd',
      component: RegSuccessPwd
    },
    {
      path: '/resetSuccesspwd',
      name: 'resetSuccesspwd',
      component: ResetSuccessPwd
    },
    {
      path: '/home',
      name: 'account',
      component: HomeMenu,
      children: [
        {
          path: 'account',
          component: Account,
          name: 'account',
          mete: {
            activename: 'account'
          }
        },
        {
          path: 'message',
          component: Message,
          name: 'message',
          mete: {
            activename: 'message'
          }
        },
        {
          path: 'orders',
          component: OrderList,
          name: 'orders',
          mete: {
            activename: 'orders'
          }
        },
        {
          path: 'dataOrders',
          component: OrderList,
          name: 'dataOrders',
          mete: {
            activename: 'orders'
          }
        },
        {
          path: 'subscriptionOrders',
          component: SubscriptionOrdersList,
          name: 'subscriptionOrders',
          mete: {
            activename: 'subscriptionOrders'
          }
        },
        {
          path: 'changepwd',
          component: ChangePwd,
          name: 'account',
          mete: {
            activename: 'user'
          }
        },
        {
          path: 'authorcenter',
          component: AuthCenter,
          name: 'account',
          mete: {
            activename: 'user'
          }
        },
        {
          path: 'address',
          component: Address,
          name: 'account',
          mete: {
            activename: 'address'
          }
        }, {
          path: 'cloudDisk',
          component: CloudDisk,
          name: 'cloudDisk'
        }, {
          path: 'cloudDiskOne',
          component: CloudDiskOne,
          name: 'cloudDiskOne'
        }, {
          path: 'clouddisktwo',
          component: CloudDiskTwo,
          name: 'clouddisktwo'
        }, {
          path: 'ftpmanager',
          component: FtpManager,
          name: 'ftpmanager'
        },
        {
          path: 'orderdetail',
          name: 'orderdetail',
          component: OrderDetail
        },
        {
          path: 'voucher',
          name: 'voucher',
          component: Vouchers
        },
        {
          path: 'invoice',
          name: 'invoice',
          component: Invoice
        },
        {
          path: 'getinvoice',
          name: 'invoice',
          component: GetInvoice
        },
        {
          path: 'managerinvoice',
          name: 'invoice',
          component: ManagerInvoice
        }, {
          path: 'geturl',
          component: GetUrl,
          name: 'geturl'
        }
      ]
    },
    {
      path: '/comment',
      name: 'comment',
      component: Comment
    },
    {
      path: '/remoteSenseData',
      name: 'mainindex',
      component: Main
    },
    {
      path: '/subscriptionData',
      name: 'mainindex',
      component: Main
    },
    {
      path: '/remoteSenseProduct',
      name: 'mainindex',
      component: Main
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (document.getElementById('head')) {
    if (to.path === '/' || to.path === '/remoteSenseProduct' || to.path === '/remoteSenseData' || to.path === '/subscriptionData') {
      // 首页头部样式
      document.getElementById('head').style.position = 'absolute'
      // 首页尾部样式
      document.getElementById('footer').style.position = 'absolute'
    } else {
      // 其它页头部样式
      document.getElementById('head').style.position = 'relative'
      // 其它页尾部样式
      document.getElementById('footer').style.position = 'relative'
      // 其它页中部样式
      if (document.getElementById('main')) {
        document.getElementById('main').style.height = 'auto'
        document.getElementById('main').style.overflow = 'hidden'
      }
    }
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js